// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MainRoutes_MainRoutes__HjuNn {
  width: 100%;
  height: 85vh;
  overflow-y: hidden;
  background: #F0F2F5;
  padding: 0 24px 0;
}`, "",{"version":3,"sources":["webpack://./src/components/modules/app/components/MainRoutes/MainRoutes.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AACF","sourcesContent":[".MainRoutes {\n  width: 100%;\n  height: 85vh;\n  overflow-y: hidden;\n  background: #F0F2F5;\n  padding: 0 24px 0;\n}\n//\n//.MainRoutes::-webkit-scrollbar {\n//  width: 4px;\n//}\n//\n//.MainRoutes::-webkit-scrollbar-thumb {\n//  background-color: #04867a;\n//  border-radius: 50px;\n//}\n//\n//.MainRoutes::-webkit-scrollbar-track {\n//  background: #e2e4e7;\n//}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"MainRoutes": `MainRoutes_MainRoutes__HjuNn`
};
export default ___CSS_LOADER_EXPORT___;
